export const SLATE_LIST_INDENTS = {
  indent_left: 'indent-left',
  indent_right: 'indent-right',
};
